export class DpEvent {
    private _isStopped: boolean = false;

    public stopPropagation(): void {
        this._isStopped = true;
    }

    public isStopped(): boolean {
        return this._isStopped;
    }
}
